import { lab, labProgram } from "assets/svg/blue";
import { COLORS } from "helpers/utils/constants";
import { formatAddress } from "helpers/utils/utilities";
import {
  deleteValues,
  payloadBool,
  payloadFormatArray,
  payloadGetVal,
  payloadKeyVal,
  payloadKeyVals,
} from "helpers/utils/utilities";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import { isTrue } from "helpers/utils/validators";

export const browse_options = [
  { id: 1, title: "Labs", pageTitle: "Manage Labs" },
  { id: 2, title: "Lab Programs", pageTitle: "Manage Lab Programs" },
];


export const getLabNUX = (onClick) => ({
  0: {
    title: "You have no Labs to manage. Let’s create your first Lab!",
    nuxCardData: {
      title: "Create Your First Lab",
      icon: lab,
      bgColor: COLORS.DARK_BLUE,
      onClick,
    },
  },
  1: {
    title: "You have no Lab programs. Lets create your first Lab program ",
    nuxCardData: {
      title: "Create Your First Lab Program",
      icon: labProgram,
      bgColor: COLORS.DARK_BLUE,
      onClick,
    },
  },
});

export const browse_options_tabs = [
  {
    id: 1,
    title: `Browse`,
    pageTitle: "Browse Labs and Lab Programs",
  },
  {
    id: 2,
    title: `My Labs & Lab Programs`,
    pageTitle: "My Labs & Lab Programs",
  },
  {
    id: 3,
    title: "Pending Invitations",
    pageTitle: "Browse Pending Lab & Lab Programs Invitations",
  },
  {
    id: 4,
    title: "Saved",
    pageTitle: "Browse Saved Labs & Lab Programs",
  },
];


export const labPayload = ({data,socialLinks, challenges, resources, isLiveEventVerifed, editMode, experts}) =>{
     const salaryPaymentFrequencyMapping = { zero: 0, one: 1, two: 2, three: 3 };
      const payload = {
        ...data,
        ...(data?.location || {}),
        location:
          typeof data?.location === "string"
            ? data?.location
            : formatAddress(data?.location),
        external_links: payloadFormatArray(socialLinks, "url"),
        external_link_ids: payloadFormatArray(socialLinks, "type"),
        challenges: challenges?.selected
          .filter((d) => d.type === COMPONENT_TYPES.CHALLENGE)
          .map((challenge) => challenge.uuid),
        challenge_paths: challenges?.selected
          .filter((d) => d.type === COMPONENT_TYPES.CHALLENGE_PATH)
          .map((challenge) => challenge.uuid),
        resource_modules: resources?.selected
          .filter((d) => d.type === "module")
          .map((d) => d.uuid),
        resource_collections: resources?.selected
          .filter((d) => d.type === "collection")
          .map((d) => d.uuid),
        resource_groups: resources?.selected
          .filter((d) => d.type === "group")
          .map((d) => d.uuid),
        integrate_campus_connect: data?.campus_connect
          ? data?.integrate_campus_connect
          : "no",
        campus_connect_salary_payment_frequency:
          salaryPaymentFrequencyMapping[
            data?.campus_connect_salary_payment_frequency
          ],
        campus_connect_has_image_file: Boolean(
          data?.campus_connect_story_image instanceof File
        ),
        is_live_event_enabled: data?.is_live_event_enabled ? "yes" : "no",
        ...(data?.is_live_event_enabled
          ? {
              "live_event[url]": data?.live_event_url,
              "live_event[is_verified]": isLiveEventVerifed ? "yes" : "no",
            }
          : {}),
        media_type:
          data?.iframe_code ||
          (typeof data?.cover_image === "string" &&
            data?.cover_image?.startsWith("<iframe"))
            ? "embedded"
            : "image",
        cover_image: data?.iframe_code ? data?.iframe_code : data?.cover_image,
        is_achievement_enabled: payloadBool(data?.is_achievement_enabled),
        expert_references: experts?.map((d) => d?.email),
        is_pre_built_achievement: payloadBool(
          Boolean(data?.pre_built_achievement_id)
        ),
      };
  
      if (isTrue(payload.is_pre_built_achievement))
        payload["achievement_id"] = data.pre_built_achievement_id;
  
      payloadKeyVal(payload, ["level_id", "duration_id", "category_id"]);
      payloadKeyVals(payload, [
        "skills",
        "skill_groups",
        "skill_stacks",
        "external_link_ids",
        "achievement_conditions",
        "lab_programs",
      ]);
      payloadGetVal(payload, ["campus_connect_schools"]);
      const deleteVals = [
        "showLab",
        "users",
        "associatedPrograms",
        "organization",
        "address_1",
        "zip_code",
        "zip",
        "campus_connect",
        "address",
        "iframe_code",
        "pre_built_achievement_id",
      ];
      if (!data?.category_id?.key) {
        deleteVals.push("category_id");
      }
      if (!data.skill_groups || !data.skill_groups.length) {
        deleteVals.push("skill_groups");
      }
      if (!data.skill_stacks || !data.skill_stacks.length) {
        deleteVals.push("skill_stacks");
      }
      if (!editMode && !payload.cover_image) {
        deleteVals.push(...["media_type", "cover_image"]);
      }
      if (editMode) {
        if (
          !payload.cover_image ||
          (payload.media_type !== "embedded" &&
            typeof payload.cover_image === "string")
        ) {
          deleteVals.push("cover_image");
        }
        if (typeof payload?.achievement_image === "string")
          deleteVals.push("achievement_image");
      }
      deleteValues(payload, deleteVals);

      return payload;
}